import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/org',
    name: 'org',
    component: () => import('../views/org.vue')
  },
  {
    path: '/toc',
    name: 'toc',
    component: () => import('../views/toc.vue')
  },
  {
    path: '/dpbox',
    name: 'dpbox',
    component: () => import('../views/dpbox.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/area',
    name: 'area',
    component: () => import( '../views/area.vue')
  },
  {
    path: '/site',
    name: 'site',
    component: () => import( '../views/site.vue')
  },
  {
    path: '/station',
    name: 'station',
    component: () => import( '../views/station.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if(sessionStorage.getItem('isok')){
    next()
  }else if(to.name !== 'login'){
    next({
      path: '/'
    })
  } else {
    next()
  }
})

export default router
